import React, { useState, useEffect, useCallback } from "react";

import { makeStyles, Grid, Modal } from "@material-ui/core";

import ReactPaginate from "react-paginate";

import ImageViewer from "react-simple-image-viewer";

import ParceirosF from "./ParceirosF";

import api from "../service/api";

export default function ListarFotos({ idAlbum }) {
  const classes = useStyles();
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [postsLastPage, setPostsLastPage] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [photosUrl, setPhotosUrl] = useState([]);
  const [openModal, setOpenModal] = React.useState(false);

  const updateData = useCallback((response) => {
    if (response && Array.isArray(response.data)) {
      const totalPages = Math.ceil((response.total || response.data.length) / 28);
      setPostsLastPage(totalPages || 1);

      const photosUrl = response.data.map((photo) => {
        if (photo.urls && photo.urls.length > 0) {
          return photo.urls[0].source;
        }
        return '';
      }).filter(url => url !== '');

      setPhotosUrl(photosUrl);
    } else {
      setPostsLastPage(1);
      setPhotosUrl([]);
    }
  }, []);

  const getPosts = useCallback(
    async (page) => {
      setLoading(true);

      const url = page
        ? `/albums/${idAlbum}/photos?limit=28&offset=${(page - 1) * 28}`
        : `/albums/${idAlbum}/photos?limit=28&offset=0`;

      api
        .get(url)
        .then((response) => updateData(response))
        .catch(e => console.log(e.message))
        .finally(() => setLoading(false));

      setCurrentPage(page - 1);
    },
    [idAlbum, updateData]
  );

  useEffect(() => {
    getPosts();
  }, [getPosts]);

  const openImageViewer = useCallback((index) => {
    setOpenModal(true);
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setOpenModal(false);
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <>
      <div className={classes.root}>
        {!loading ? (
          <>
            <Grid
              container
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              xs={12}
              spacing={4}
            >
              {photosUrl?.map((photo, index) => (
                <Grid key={photo} item xs={12} sm={6} md={4} lg={3}>
                  <div className={classes.item}>
                    <img
                      src={photo}
                      onClick={() => openImageViewer(index)}
                      key={index}
                      alt=""
                      className={classes.img}
                    />
                  </div>
                </Grid>
              ))}
            </Grid>
            {isViewerOpen ? (
              <Modal open={openModal}>
                <ImageViewer
                  src={photosUrl}
                  disableScroll={true}
                  closeOnClickOutside={true}
                  currentIndex={currentImage}
                  onClose={closeImageViewer}
                  backgroundStyle={{
                    backgroundColor: "rgba(0,0,0,0.9)",
                  }}
                />
              </Modal>
            ) : (
              <ReactPaginate
                pageCount={postsLastPage}
                previousLabel=""
                nextLabel=""
                pageRangeDisplayed={3}
                marginPagesDisplayed={1}
                onPageChange={({ selected }) => getPosts(selected + 1)}
                containerClassName="container"
                pageClassName={classes.page}
                activeClassName="active"
                pageLinkClassName="pageLink"
                forcePage={currentPage}
              />
            )}
          </>
        ) : (
          <div>
            <span>Carregando...</span>
          </div>
        )}
      </div>
      <ParceirosF />
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    marginBottom: "64px",
  },
  item: {
    height: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  img: {
    width: "100%",
    maxWidth: "350px",
  },
  page: {
    cursor: "pointer",
    fontFamily: "Karla",
    width: "30px",
    height: "30px",
    borderRadius: "20px",
  },
}));
